<template>
  <div>
    <vs-prompt
      title="Add interest"
      @cancel="val = ''"
      @accept="accept"
      @close="close"
      :active.sync="prompt"
      accept-text="Add"
      :is-valid="validForm"
      class="todoPopup"
    >
      <vs-row>
        <vs-col vs-w="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Interest key</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input class="inputx w-full" placeholder="eg. Favorite drink" v-model="name" />
            </div>
          </div>
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col vs-w="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Icon</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-row v-if="icon != ''" class="mb-4">
                <feather-icon :icon="icon"></feather-icon>
              </vs-row>
              <vs-row class="h-64 overflow-y-scroll">
                <div class="m-1 cursor-pointer" @click="icon = i.name" v-for="i in icons" :key="i.name">
                  <feather-icon :icon="i.name"></feather-icon>
                </div>
              </vs-row>
            </div>
          </div>
        </vs-col>
      </vs-row>
    </vs-prompt>
  </div>
</template>

<script>
import * as icons from "vue-feather-icons";
import FeatherIcon from "../../../../components/FeatherIcon.vue";

export default {
  components: { FeatherIcon },
  data() {
    return {
      name: "",
      icon: "",
      prompt: false,
      icons,
    };
  },
  computed: {
    validForm() {
      return this.name !== "" && this.icon !== "";
    },
  },
  methods: {
    show() {
      this.name = "";
      this.prompt = true;
    },
    async accept() {
      const dto = {
        name: this.name,
        icon: this.icon,
      };

      this.$vs.loading();

      await this.$store.dispatch("guestSegmentation/addInterest", dto);

      this.$vs.notify({
        color: "success",
        title: `Added`,
        text: "Added",
      });
      this.$vs.loading.close();
    },
    close() {},
  },
};
</script>

<style lang="scss" scoped>
</style>
